import * as validators from '../utilities/form/formValidators';

// Define validator types.
const inputLength = (formValues, id, validator, child) => {
  const input = formValues[id];
  // Only validate if required or has value.
  if (child.required || input) {
    const validatorValues = validator.values ? validator.values[0] : 2;
    return validators.validateInputLength(input, validatorValues);
  }
  return true;
};

const phoneNumber = (formValues, id, child) => {
  const input = formValues[id];
  if (child.required || input) {
    return validators.validatePhoneNumber(input);
  }
  return true;
};

const email = (formValues, id) => {
  const input = formValues[id];
  return validators.validateEmail(input);
};

const lettersOnly = (formValues, id) => {
  const input = formValues[id];
  return !validators.validateInputNumberOnly(input);
};

const numberOnly = (formValues, id) => {
  const input = formValues[id];
  return validators.validateInputNumberOnly(input);
};

const blocker = (formValues, id, validator) => {
  const input = formValues[id];
  const validatorValues = validator.values ? validator.values : [];
  return validators.validateBlocker(input, validatorValues);
};

const formHasValues = (formValues, id, validator, child) => {
  if (child.required) {
    return validators.formHasValues(formValues, child.formValues);
  }
  return true;
};

const formHasAnyValues = (formValues, id, validator, child) => {
  return validators.formHasAnyValues(formValues, child.formValues);
};

const cpr = (formValues) => {
  const input = formValues.cpr;
  return validators.validateCpr(input);
};

const minDate = (formValues, id, validator) => {
  const input = formValues[id];
  return validators.validateMinDate(input, formValues, validator.values[0], validator.values[1]);
};

const maxDate = (formValues, id, validator) => {
  const input = formValues[id];
  return validators.validateMaxDate(input, formValues, validator.values[0], validator.values[1]);
};

export const validatorMap = {
  blocker,
  email,
  formHasValues,
  formHasAnyValues,
  inputLength,
  lettersOnly,
  numberOnly,
  phoneNumber,
  cpr,
  minDate,
  maxDate,
};



// WEBPACK FOOTER //
// ./src/constants/Validators.js